export default "__VITE_ASSET__DgvhBGec__"